<template>
  <div>
    <div class="app-toolbar1"><el-button type="primary" size="small" @click="toAdd">添加</el-button></div>
    <el-table :data="systems" :stripe="true" v-loading="loading">
      <el-table-column prop="name" label="后端系统名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="desc" label="后端系统描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="projectName" label="所属项目" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="155"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" width="155"></el-table-column>
      <el-table-column fixed="right" label="操作" width="143">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm">
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-width="130px">
        <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="form.projectId" placeholder="所属项目" style="width:100%;">
            <el-option v-for="project in projects" :key="project.projectId" :label="project.name" :value="project.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="后端系统名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入后端系统名称" :maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="后端系统API地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入后端系统API地址，多个后端地址用英文逗号分割" :maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="后端系统描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请输入后端系统描述" :maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'cg-system-manage',
  data () {
    return {
      loading: false,
      systems: [],
      showForm: false,
      formTitle: '添加后端系统',
      form: {
        projectId: null,
        systemId: null,
        name: null,
        url: null,
        desc: null
      },
      formRule: {
        projectId: [{ required: true, message: '请选择项目名称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入后端系统名称', trigger: 'blur' }],
        url: [{ required: true, message: '请输入后端系统API地址', trigger: 'blur' }]
      },
      projects: []
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: '/api/cgSystems'
      }).then((res) => {
        this.systems = res.data.data
        this.loading = false
      })
    },
    loadProjects () {
      this.$http.request({
        method: 'get',
        url: '/api/cgProjects'
      }).then((res) => {
        this.projects = res.data.data
      })
    },
    toAdd () {
      this.loadProjects()
      this.formTitle = '添加后端系统'
      this.form = { projectId: null, systemId: null, name: null, url: null, desc: null }
      this.showForm = true
    },
    toUpdate (row) {
      this.loadProjects()
      this.formTitle = '修改后端系统'
      this.form = { projectId: row.projectId, systemId: row.systemId, name: row.name, url: row.url, desc: row.desc }
      this.showForm = true
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该后端系统吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let systemId = this.form.systemId
          this.$http.request({
            method: !systemId ? 'post' : 'put',
            url: !systemId ? '/api/cgSystems' : `/api/cgSystems/${systemId}`,
            data: JSON.stringify(this.form)
          }).then(() => {
            this.showForm = false
            this.load()
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgSystems/${data.systemId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load()
        })
      }
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
